import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
	{
		path: "/",
		name: "home"
	},
	{
		path: "/",
		name: "about"
	},
	{
		path: "/",
		name: "skills"
	},
	{
		path: "/",
		name: "xp"
	},
	{
		path: "/",
		name: "services"
	},
	{
		path: "/",
		name: "portfolio"
	},
	{
		path: "/",
		name: "contact"
	},
	{
		path: "*",
		component: () => import("../components/404.vue")
	}
];

const router = new VueRouter({
	mode: "history",
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition; // Return a saved position if one's available
		} else if (to.hash) {
			return { selector: to.hash }; // Return a hash if set
		} else {
			return { x: 0, y: 0 }; // Return to the top
		}
	}
});

export default router;
